export function computeRoleSelectionState(param_kendogrid, translate) {
    let enableEditButton = false;
    let enableRoleButton = false;
    let enableDeleteButton = false;
    let roleTemplateDisableNote = '';
    let deleteButtonDisabledText = translate('RoleManager_Tooltip_Delete_SelectOne');
    let selectRoleData = null;

    if (param_kendogrid.getNumberOfSelections() !== 1) {
        return {
            roleTemplateDisableNote,
            enableEditButton,
            enableRoleButton,
            enableDeleteButton,
            deleteButtonDisabledText,
            selectRoleData,
        };
    }

    const row = param_kendogrid.getItem(param_kendogrid.getKeys());
    selectRoleData = row;
    enableRoleButton = row.Name !== 'superadmin';

    if (row.IsTemplate === true) {
        roleTemplateDisableNote = translate('Template_Role_Note');
        deleteButtonDisabledText = translate('Template_Role_Note');
    } else {
        enableEditButton = true;

        if (row.InUse === true) {
            deleteButtonDisabledText = translate('RoleManager_Tooltip_Delete_InUse');
        } else if (row.InUse == false) {
            enableDeleteButton = true;
            deleteButtonDisabledText = '';
        }
    }

    return {
        roleTemplateDisableNote,
        enableEditButton,
        enableRoleButton,
        enableDeleteButton,
        deleteButtonDisabledText,
        selectRoleData,
    };
}
